export const ListQueryKey = 'rafflereWards';
export const DetailQueryKey = 'rafflereWard';

export const Urls = {
  selectUrl: '/rafflereward/list',
  updateUrl: '/rafflereward/update',
  deleteUrl: '/rafflereward/delete',
  createUrl: '/rafflereward/create',
  detailUrl: '/rafflereward/detail',
};
